import React from 'react';

import {
  widgetDefaultProps,
  widgetPropType,
} from '@glowforge/gf-styled/models';

import Catalog from './catalog';

const CatalogWidget = ({ sections }) => {
  const { title, bodyContent, image } =
    sections.find(
      (section) => section.fields?.id === 'catalog-section-homepage'
    )?.fields ?? {};

  const button = sections.find(
    (section) => section.fields?.id === 'browse-catalog-designs'
  );

  const imageUrl = image?.fields?.file?.url ?? '';

  return (
    <Catalog
      title={title}
      bodyContent={bodyContent}
      image={imageUrl}
      button={button}
    />
  );
};

CatalogWidget.propTypes = widgetPropType;
CatalogWidget.defaultProps = widgetDefaultProps;

export default CatalogWidget;
